"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROJECT_NAME = void 0;
exports.PROJECT_NAME = "harken";
